<template>
  <div class="std-background">
    <v-card width="500" class="mx-auto my-3">
      <div class="std-title std-title--divider">
        <h2>Our Privacy Policy</h2>
        <h3 class="std-title--description">Here at Dr. Asmah Health Hub, we take the security of your personal information very seriously!</h3>
      </div>
      <div class="checklist__form" :class="{'ma-2 pa-3': $vuetify.breakpoint.smAndDown}">
        <ol class="grayWording--text">
          <li><p>We only collect and discreetly utilize the information that you provide to us voluntarily.</p></li>
          <li><p>We may use your information to contact you in the future for reassessment after the treatment or for future promotions.</p></li>
          <li><p>We will not rent or sell your information to third parties outside Dr Asmah Health Hub and its group companies (including any parent, subsidiaries ad affiliates) without your consent.</p></li>
          <li><p>You can contact us by our contact detail if you do not want us to collect or use your information, or if you would like us to delete or change the information that we have obtained.</p></li>
          <li><p class="mb-0">Any sections of this website that collects personal information is encrypted to protect it and is only assessed by our trusted employees at any given time.</p></li>
        </ol>
        <p class="mt-5">If you have concerns regarding how we're using your information, please do not hesitate to <a href="https://www.instagram.com/drasmah_healthhub" target="_blank">CONTACT US</a> on Instagram and we will get back to you shortly.</p>
        <div class="text-center mt-5">
          <v-btn depressed color="primaryLight" class="white--text" @click="$router.go(-1)">Got it! Take me back</v-btn>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'PrivacyPolicy'
  }
</script>
